/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationAudits {
    getFixupPrototypeFunction() { return RecommendationAudits.fixupPrototype; }

    static newInstance(model: Partial<RecommendationAudits>): RecommendationAudits {
        let obj = Object.assign(new RecommendationAudits(), model);
        RecommendationAudits.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationAudits>): RecommendationAudits {
        if (!model) return null;
        return RecommendationAudits.newInstance(<RecommendationAudits> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationAudits) {
        if (!obj) return;

        models.RecommendationAudits.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationAudits): boolean {
        Object.setPrototypeOf(obj, RecommendationAudits.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.workflow_details) {
            for (let val of this.workflow_details) {
                models.WorkFlowImpacts.fixupPrototype(val);
            }
        }
    }

    workflow_details: Array<models.WorkFlowImpacts>;

    /**
     * Ids for the dimension which impacted this resource
     */
    dimension_ids: Array<string>;

    /**
     * Ids for the exclusion rules which impacted this resource
     */
    exclusion_rule_ids: Array<string>;

}
